import { render, staticRenderFns } from "./ImportCustomizedProducts.vue?vue&type=template&id=6f6a8b16"
import script from "./ImportCustomizedProducts.vue?vue&type=script&lang=js"
export * from "./ImportCustomizedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports